<template>
  <Achievement v-if="achievement" @back="next()">
      {{achievement.title}}
  </Achievement>
  <Rtos v-else :rto-categories="rtoCategories" :action-text="actionText" key="rtos" @back="next()" title></Rtos>
</template>

<script>
  import Rtos from "./Rtos";
  import Achievement from "../profile/Achievement";
  export default {
    name: "RtoRenderer",
    components:{Rtos,Achievement},
    props:{
      rtoCategories: {
        required: true,
        type: Object
      },
      actionText: {
        type: String,
        default: 'Back'
      },
      title: {
        type: Boolean,
        default: false
      }
    },
    computed:{
      achievement(){
        if(this.rtoCategories && Object.keys(this.rtoCategories).length===1){
          const rtos = this.rtoCategories[Object.keys(this.rtoCategories)[0]];
          for(let rto of rtos['rtos']){
            if(rto && rto.rto_type==='achievement' && rto.title){
              return rto;
            }
          }
          return false;
        }
        return false;
      }
    },
    mounted(){

    },
    methods:{
      next(){
        this.$emit('next');
      }
    }
  }
</script>

<style scoped>

</style>